export const FILTER_LABELS = {
  ALL: 'Tous types de paiement',
  ONLINE: 'Paiement en ligne',
  ONSITE: 'Paiement au retrait',
};
